module.exports = __webpack_public_path__ + "static/media/u-soffa.4d3222b0.jpg";